// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 4000;
  }
  .popup-error{
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    border-color: #721c24;
  }
  .popup-ok{
    background-color: #e3f8d7;
    color: #2d721c;
    border: 1px solid #d7f5c6;
    border-color: #2d721c;
  }
  .popup-content {
    width: 400px;
    min-height: 80px;
    border-radius: 4px;
    padding: 10px;
    max-width: 500px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    animation: fadeInUp 0.5s ease-in-out;
    display: flex;
    /* max-height: 80px; */
  }
  
  .close-btn {
    cursor: pointer;
    float: right;
    font-size: 18px;
    top: 5px;
    right: 10px;
    position: absolute;
  }
  .popup-cont-img{
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popup-img{
    width: 50%;
    /* height: 15%; */
  }
  .popup-cont-info{
    display: block;
    width: 80%;
  }
  .popup-title{
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: larger;
    /* height: 30%; */
    /* position: absolute; */
    top:5px;
  }
  .popup-text{
    display: flex;
    justify-content: center;
    font-size: medium;
    text-align: center;
    /* height: 70%; */
    align-items: center;
    margin-top: 10px;
  }
  .popup-text-min{
    display: flex;
    justify-content: center;
    font-size: small;
    text-align: center;
    margin-top: 10px;
    /* height: 70%; */
    align-items: center;
  }
  @keyframes fadeInUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/generales/styles/Popup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,uCAAuC;IACvC,oCAAoC;IACpC,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,OAAO;EACT;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF","sourcesContent":[".popup-container {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    z-index: 4000;\r\n  }\r\n  .popup-error{\r\n    background-color: #f8d7da;\r\n    color: #721c24;\r\n    border: 1px solid #f5c6cb;\r\n    border-color: #721c24;\r\n  }\r\n  .popup-ok{\r\n    background-color: #e3f8d7;\r\n    color: #2d721c;\r\n    border: 1px solid #d7f5c6;\r\n    border-color: #2d721c;\r\n  }\r\n  .popup-content {\r\n    width: 400px;\r\n    min-height: 80px;\r\n    border-radius: 4px;\r\n    padding: 10px;\r\n    max-width: 500px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    animation: fadeInUp 0.5s ease-in-out;\r\n    display: flex;\r\n    /* max-height: 80px; */\r\n  }\r\n  \r\n  .close-btn {\r\n    cursor: pointer;\r\n    float: right;\r\n    font-size: 18px;\r\n    top: 5px;\r\n    right: 10px;\r\n    position: absolute;\r\n  }\r\n  .popup-cont-img{\r\n    width: 20%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .popup-img{\r\n    width: 50%;\r\n    /* height: 15%; */\r\n  }\r\n  .popup-cont-info{\r\n    display: block;\r\n    width: 80%;\r\n  }\r\n  .popup-title{\r\n    display: flex;\r\n    justify-content: center;\r\n    font-weight: bold;\r\n    font-size: larger;\r\n    /* height: 30%; */\r\n    /* position: absolute; */\r\n    top:5px;\r\n  }\r\n  .popup-text{\r\n    display: flex;\r\n    justify-content: center;\r\n    font-size: medium;\r\n    text-align: center;\r\n    /* height: 70%; */\r\n    align-items: center;\r\n    margin-top: 10px;\r\n  }\r\n  .popup-text-min{\r\n    display: flex;\r\n    justify-content: center;\r\n    font-size: small;\r\n    text-align: center;\r\n    margin-top: 10px;\r\n    /* height: 70%; */\r\n    align-items: center;\r\n  }\r\n  @keyframes fadeInUp {\r\n    from {\r\n      transform: translateY(20px);\r\n      opacity: 0;\r\n    }\r\n    to {\r\n      transform: translateY(0);\r\n      opacity: 1;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
